import script from "./ClientAnalyticsEventHandler.vue?vue&type=script&lang=js"
export * from "./ClientAnalyticsEventHandler.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__